import { render } from "./SubmenuOrganic.vue?vue&type=template&id=88f3e476"
import script from "./SubmenuOrganic.vue?vue&type=script&lang=js"
export * from "./SubmenuOrganic.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__